import React, { useState, useEffect } from "react";

import { CLink } from "@coreui/react";
import { RiAddLine, RiEyeFill } from "react-icons/ri";
import "./style.scss";

const AdminDashboardButton = props => {
  const [active, setActive] = useState(false);
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const touchMediaQuery = window.matchMedia("(pointer: coarse)");
    setIsTouchDevice(touchMediaQuery.matches);
  }, []);

  const handleInteraction = state => {
    // Verifica é mobile/touch
    if (!isTouchDevice) setActive(state);
  };
  const handleClick = e => {
    // No mobile, o clique alterna o estado
    if (isTouchDevice) {
      if (e.target.closest("a")) return;
      setActive(!active);
    }
  };

  return (
    <div
      className={`p-0 border-default rounded-lg admin-dashboard-button ${
        props.className || ""
      }`}
      onClick={handleClick}
      onMouseEnter={() => handleInteraction(true)}
      onMouseLeave={() => handleInteraction(false)}
      style={{
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        cursor: "pointer"
      }}
    >
      {active && (
        <div
          className="d-flex justify-content-center align-items-center p-2 bg-white text-dark w-100"
          style={{ borderBottom: "none", borderRadius: "0" }}
        >
          <props.icon size={20} className="mr-2" />
          <span style={{ fontSize: "0.9rem" }}>{props.title}</span>
        </div>
      )}
      <div
        className="content-area text-white flex-grow-1"
        style={{
          backgroundColor: props.color,
          width: "100%",
          borderRadius: "0", // Força a emenda interna a ser SEMPRE reta
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        {active ? (
          <div className="d-flex flex-column w-100 h-100 justify-content-center">
            {props.create && (
              <>
                <CLink
                  className="action-link text-white d-flex align-items-center justify-content-center"
                  to={props.create}
                >
                  {props.firstLinkLabel || "Criar"}
                  <RiAddLine size={24} className="ml-3" />
                </CLink>
                <hr className="border-white w-75 m-0 align-self-center" />
              </>
            )}
            <CLink
              className="action-link text-white d-flex align-items-center justify-content-center"
              to={props.view}
            >
              {props.secondLinkLabel || "Visualizar"}
              <RiEyeFill size={24} className="ml-3" />
            </CLink>
          </div>
        ) : (
          <props.icon size={64} />
        )}
      </div>
      {!active && (
        <div
          className="p-3 text-center w-100 bg-white"
          style={{ borderTop: "none", borderRadius: "0" }}
        >
          <span>{props.title}</span>
        </div>
      )}
    </div>
  );
};

export default AdminDashboardButton;
